import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DiffDialogComponent, DiffDialogData } from '@y42/monaco-editor';
import { Observable } from 'rxjs';
import { JobSettingsValidationResults, JobSettingsValidationType } from '../../state';
import { JobSettingsValidationFormatterService } from './job-settings-validation-formatter.service';

@Injectable()
export class JobRequestDialogService {
  constructor(
    private readonly dialog: MatDialog,
    protected readonly jobSettingsValidationFormatterService: JobSettingsValidationFormatterService,
  ) {}

  open(data: JobSettingsValidationResults<never, JobSettingsValidationType> | undefined): Observable<void> {
    return this.dialog
      .open<DiffDialogComponent, DiffDialogData>(DiffDialogComponent, {
        width: '80vw',
        height: '80vh',
        panelClass: ['full-screen-popup'],
        autoFocus: false,
        data: {
          title: `Job Request Settings Diff`,
          diffs: Object.values(data ?? {}).map((result) => ({
            filePath: result.filePath,
            content1: result.content1AsJson.props
              ? this.jobSettingsValidationFormatterService.stringify(
                  result.content1AsJson.data as Record<string, unknown>,
                  result.content1AsJson.props,
                )
              : (result.content1AsJson.data as string),
            content2: result.content2AsJson.props
              ? this.jobSettingsValidationFormatterService.stringify(
                  result.content2AsJson.data as Record<string, unknown>,
                  result.content2AsJson.props,
                )
              : (result.content2AsJson.data as string),
            showDiff: !result.isValid,
          })),
        },
      })
      .afterClosed();
  }
}
